import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('쇼핑몰 코드 조회', v10APIs),
    mergeVersionsByTitle('쇼핑몰 계정 등록', v10APIs),
    mergeVersionsByTitle('쇼핑몰 계정 수정', v10APIs),
    mergeVersionsByTitle('쇼핑몰 계정 삭제', v10APIs),
  ].filter(Boolean);

  return { title: '쇼핑몰계정 관리', children };
};

export default data;
